import { Component, OnInit } from '@angular/core';

const NAVLINKS = [
  {title: 'Købmandsregning', link:'/crossery', content:'.'},
  {title: 'Renteregning', link:'/procent', content:'.'},
  {title: 'Afstandsøvelser', link:'/planyourtrip', content:'.'}
];

@Component({
  selector: 'app-menu-inaction',
  templateUrl: './menu-inaction.component.html',
  styleUrls: ['./menu-inaction.component.css']
})
export class MenuInactionComponent implements OnInit {

  navLinks = NAVLINKS;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/menu-inaction/menu-inaction.component.ts